(function () {
  'use strict';

  var module = angular.module('uwAgenda.global');
  /* main auths service for login and logout */
  module.factory('AuthenticationService', [
    '$http',
    'SharedAgendaService',
    'settings',
    'WebsocketService',
    '$rootScope',
    'RoleType',
    function (
      $http,
      SharedAgendaService,
      settings,
      WebsocketService,
      $rootScope,
      RoleType) {

      // logged-out-manually 
      this.ManualLogOut = false;
      let CorilusPassportIdToken = null;

      var baseUrl = '/api/authorization';

      var service = {
        login: login,
        swapToken: swapToken,
        loginViaCorilusPassport: loginViaCorilusPassport,
        logout: logout,
        isInRole: isInRole,
        setAuthenticationHeader: setAuthenticationHeader,
        forceLogOut: forceLogOut,
        setCorilusPassportIdToken: setCorilusPassportIdToken,
        getCorilusPassportIdToken: getCorilusPassportIdToken,
        clearCorilusPassportIdToken: clearCorilusPassportIdToken,
        saveRolesOfLoggedInUserInRootScope: saveRolesOfLoggedInUserInRootScope
      };

      return service;


      // authenticate user
      function login(username, password) {
        // reset http Header
        setAuthenticationHeader(null);
        this.ManualLogOut = false;
        // login
        return $http.post(baseUrl, {username: btoa(username), password: btoa(password)}, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': undefined
          },
          transformRequest: function (obj) {
            var str = [];
            for (var p in obj) {
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
            return str.join("&");
          }
        }).then(function (response) {
          //return JSON.parse(response.data);
          return response.data;
        });

      } // login

      // authenticate user via Corilus Passport
      function loginViaCorilusPassport(id_token, userId) {
        var requestBody = {};

        if (userId != null) {
          requestBody.userId = userId;
        }
        
        return $http.post(baseUrl + '/coriluspassport', requestBody, {
            headers: {
              'Authorization': `Bearer ${id_token}`
            },
          })
          .then(function (response) {
            return response.data;
          });
      }

      function swapToken() {
        return $http.post(baseUrl + '/swap-token').then(function (response) { return response.data; });
      }

      // logout
      function logout(noRefresh) {
        // clear corilus passport token
        clearCorilusPassportIdToken()
        SharedAgendaService.setLoggedInUserData({});
        // reset licence branding
        settings.templateInit();
        // reset http Header
        setAuthenticationHeader(null);
        // close websocket
        WebsocketService.close();
        // clear toastr
        setTimeout(function () {
          toastr.clear();
        }, 10000);
        
        if (noRefresh) { return; }
        window.location.reload();
      } //logout

      // set authentication header
      function setAuthenticationHeader(api_token) {
        // put "Authorization Bearer" to all Request with Token
        if (api_token == null) {
          $http.defaults.headers.common.Authorization = '';
          WebsocketService.setAuthenticationToken(null);
          return;
        }
        
        $http.defaults.headers.common.Authorization = 'Bearer ' + api_token;
        WebsocketService.setAuthenticationToken(api_token);
      } // setAuthenticationHeader

      // is current user in role (checks the role types)
      function isInRole(role) {
        return -1 !== SharedAgendaService.getLoggedInUserData().roles.indexOf(role.name);
      } //isInRole


      // force logout of user 
      function forceLogOut(username) {
        return $http.put(baseUrl + '/logout/' + username).then(function (response) {
          return response.data;
        });
      }

      // set the token in memory
      function setCorilusPassportIdToken(token) {
        CorilusPassportIdToken = token;
      }

      // get the token from memory
      function getCorilusPassportIdToken() {
        return CorilusPassportIdToken;
      }

      // clear the token from memory
      function clearCorilusPassportIdToken() {
        CorilusPassportIdToken = null;
      }

      function saveRolesOfLoggedInUserInRootScope() {
        $rootScope.isRingfoonAdminOnly = isInRole(RoleType.RingfoonAdmin);
        // #147 Ringfoon-Operator-Admin has same rights as Ringfoon-Superadmin
        $rootScope.isRingfoonAdmin = isInRole(RoleType.RingfoonAdmin) || isInRole(RoleType.RingfoonOperatorAdmin);
        $rootScope.isRingfoonOperatorAdmin = isInRole(RoleType.RingfoonOperatorAdmin);
        $rootScope.isRingfoonOperator = $rootScope.isRingfoonOperatorAdmin || isInRole(RoleType.RingfoonOperatorRestricted);
        $rootScope.isRingfoonOperatorRestricted = isInRole(RoleType.RingfoonOperatorRestricted);
        $rootScope.isRingfoon = $rootScope.isRingfoonAdmin || $rootScope.isRingfoonOperator;
        $rootScope.isSubuserAdmin = isInRole(RoleType.SubuserAdmin);
        $rootScope.isSubuser = $rootScope.isSubuserAdmin || isInRole(RoleType.SubuserRestricted);
        $rootScope.isColleague = isInRole(RoleType.Colleague);
        $rootScope.isMainuser = isInRole(RoleType.MainUser);
        $rootScope.isMainAgendaAdmin = $rootScope.isRingfoonAdmin || $rootScope.isMainuser || $rootScope.isSubuserAdmin;
        $rootScope.isAllowedToSeeSensitiveInfo = $rootScope.isRingfoonAdminOnly || $rootScope.isMainuser || $rootScope.isSubuserAdmin;
      }

    }]);
})();